import React from 'react';
import { Link, NavLink } from "react-router-dom";
import { logOut } from './api/api.js'

const Nav = ({user, setUser}) => {

  const handleLogout = async () => {
    await logOut();
    setUser(null);
  }

  return (
    <nav className="navbar is-white">
      <div className="container">
        <div className="navbar-brand">
          <Link to="/" className="navbar-item logo">
            prefix
          </Link>
          <span className="navbar-burger burger" data-target="navbarMenuHeroB">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
        <div id="navbarMenuHeroB" className="navbar-menu">
          <div className="navbar-end">
            <NavLink to="/exercise" activeClassName="is-active" className="navbar-item">
              Vežbanje
            </NavLink>
            <NavLink to="/theory" activeClassName="is-active" className="navbar-item">
              Teorija
            </NavLink>
            { !user ? (
                <span className="navbar-item">
                  <NavLink to="/account" className="button is-dark is-inverted">
                    <span className="icon">
                      <i className="fa fa-sign-in-alt" aria-hidden="true"></i>
                    </span>
                    <span>Log in</span>
                  </NavLink>
                </span>
              ) : (
                <>
                  <span className="navbar-item">
                    <NavLink to="/account" className="button is-light">
                      <span>korisnik: <strong>{user.pin}</strong></span>
                    </NavLink>
                  </span>
                  <span className="navbar-item">
                    <NavLink to="/account" className="button is-dark is-inverted" onClick={handleLogout}>
                      <span className="icon">
                        <i className="fa fa-sign-out-alt" aria-hidden="true"></i>
                      </span>
                      <span>Log out</span>
                    </NavLink>
                  </span>
                </>
              )
            }
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Nav;
